"use client";

import { GoogleOAuthProvider as GoogleOAuthProviderBase } from "@react-oauth/google";
import { PropsWithChildren } from "react";
import { getRuntimeConfig } from "@lib/runtimeEnvClient";

// We are using this only in the login page. Evaluate to move provider within Login component in CC
export function GoogleOAuthProvider({ children }: PropsWithChildren) {
  const clientId = getRuntimeConfig("NEXT_PUBLIC_GOOGLE_AUTH_CLIENT_ID");

  return (
    <GoogleOAuthProviderBase clientId={clientId}>
      {children}
    </GoogleOAuthProviderBase>
  );
}
